import { Route, Routes } from "react-router-dom";

import { Layout } from "./components/Layout";
import { RequireAuth } from "./components/RequireAuth";
import { AdminPage } from "./pages/Admin";
import { CapturePage } from "./pages/Capture";
import { CaptureViewPage } from "./pages/CaptureView";
import { DohaPage } from "./pages/Doha";
import { DohasPage } from "./pages/Dohas";
import { DrillPage } from "./pages/Drill";
import { GlossaryPage } from "./pages/Glossary";
import { GraphPage } from "./pages/Graph";
import { HelperPage } from "./pages/Helper";
import { HomePage } from "./pages/Home";
import { NotFoundPage } from "./pages/NotFound";
import { StudyPage } from "./pages/Study";
import { TermPage } from "./pages/Term";

export function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/glossary" element={<GlossaryPage />} />
        <Route path="/glossary/:slug" element={<TermPage />} />
        <Route path="/graph" element={<GraphPage />} />
        <Route path="/dohas" element={<DohasPage />} />
        <Route path="/doha/:slug" element={<DohaPage />} />
        <Route
          path="/study"
          element={
            <RequireAuth action="keep your study">
              <StudyPage />
            </RequireAuth>
          }
        />
        <Route
          path="/drill"
          element={
            <RequireAuth action="drill the glossary">
              <DrillPage />
            </RequireAuth>
          }
        />
        <Route
          path="/capture"
          element={
            <RequireAuth action="capture a doha">
              <CapturePage />
            </RequireAuth>
          }
        />
        <Route
          path="/capture/:id"
          element={
            <RequireAuth>
              <CaptureViewPage />
            </RequireAuth>
          }
        />
        <Route path="/helper" element={<HelperPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
